<div class="comparison-filter__filter-content" *transloco="let t; read: 'comparison-filter-item'">
  @if (filtersExtraDropdown) {
    <div class="comparison-filter__filter-wrapper comparison-filter__filter-extra-wrapper">
      <xi-dropdown
        [placeholder]="filtersExtraDropdown.placeholder"
        [value]="filtersExtraDropdown.value"
        [data]="filtersExtraDropdown.data"
        [stretch]="true"
        (onValueChange)="filtersExtraDropdown?.onValueChange($event.detail.selected.id)"
      ></xi-dropdown>
    </div>
  }

  <div class="comparison-filter__label-wrapper">
    <label class="comparison-filter__filter-label" for="comparison-filter__filter-name"
      >{{ t('name-label') }}
    </label>

    <xi-input-field
      inputId="comparison-filter__filter-name"
      [appAutoFocus]="isDialog ? 'xiInput' : null"
      [disabled]="!isFilterEnabled"
      [status]="filterLabelStatus"
      [(value)]="filtersLabelValue"
      [placeholder]="t('input-placeholder')"
      [prePopulateStatus]="true"
      icon="cancel"
      (onIconClick)="filtersLabelValue = ''"
    ></xi-input-field>
  </div>

  <div class="comparison-filter__color-picker comparison-filter__label-wrapper">
    <label class="comparison-filter__filter-label">{{ t('swatch') }}</label>

    <xi-color-picker
      [direction]="6"
      [selectedColor]="filtersColorValue"
      [preselectedColors]="projectColors"
      (onColorChange)="colorChange$.next($event.detail.color)"
    ></xi-color-picker>
  </div>

  <div class="comparison-filter__filter-wrapper comparison-filter__label-wrapper">
    <label class="comparison-filter__filter-label">{{ filterInputLabel }}</label>

    @if ((type === 'date' || subType === 'sectionDate') && dateType === 'regularDate') {
      <app-comparison-filter-date-item
        [field]="field"
        [filterKind]="filterKind"
        [isEnabled]="isFilterEnabled"
        [(filters)]="filtersValue"
      ></app-comparison-filter-date-item>
    }
    @if ((type === 'date' || subType === 'sectionDate') && dateType === 'dynamicDate') {
      <app-comparison-filter-dynamic-date-item
        [allFilters]="allFilters"
        [field]="field"
        [filterKind]="filterKind"
        [isEnabled]="isFilterEnabled"
        [isReadOnly]="isReadOnly"
        [(filters)]="filtersValue"
      ></app-comparison-filter-dynamic-date-item>
    }
    @if (type === 'keyword' || subType === 'sectionKeyword') {
      <app-comparison-filter-keyword-item
        [dataSource]="dataSource"
        [field]="field"
        [filterKind]="filterKind"
        [projectId]="projectId"
        [isEnabled]="isFilterEnabled"
        [isReadOnly]="isReadOnly"
        [(filters)]="filtersValue"
      ></app-comparison-filter-keyword-item>
    }
    @if (type === 'numeric' || subType === 'sectionNumeric') {
      <app-comparison-filter-numeric-item
        [field]="field"
        [filterKind]="filterKind"
        [isEnabled]="isFilterEnabled"
        [isReadOnly]="isReadOnly"
        [(filters)]="filtersValue"
      ></app-comparison-filter-numeric-item>
    }
  </div>
</div>

<div class="comparison-filter__filter-remove">
  <xi-icon-button icon="cancel_circle" (onClick)="onFiltersRemoved()"></xi-icon-button>
</div>
